import commonLogic from '@/common/locale/logic/common/common-logic';

function getLocaleResourceBase(){
  const data:any = {
      ServiceStatus: {
          "10": commonLogic.appcommonhandle("未派工",null),
          "20": commonLogic.appcommonhandle("待处理跟进",null),
          "30": commonLogic.appcommonhandle("已派单",null),
          "40": commonLogic.appcommonhandle("已响应",null),
          "50": commonLogic.appcommonhandle("预约成功",null),
          "60": commonLogic.appcommonhandle("预约失败",null),
          "70": commonLogic.appcommonhandle("已出发",null),
          "80": commonLogic.appcommonhandle("已到位",null),
          "90": commonLogic.appcommonhandle("未完工",null),
          "100": commonLogic.appcommonhandle("已完工",null),
          "110": commonLogic.appcommonhandle("已回执",null),
          "120": commonLogic.appcommonhandle("已回访",null),
          "130": commonLogic.appcommonhandle("已结单",null),
          "140": commonLogic.appcommonhandle("已结算",null),
          "150": commonLogic.appcommonhandle("已取消",null),
          "160": commonLogic.appcommonhandle("已挂起",null),
          "170": commonLogic.appcommonhandle("待改派",null),
          "180": commonLogic.appcommonhandle("待复议",null),
          "190": commonLogic.appcommonhandle("待复核",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      UserClassification: {
          "empty": commonLogic.appcommonhandle("",null),
      },
      UrgentLevel: {
          "1": commonLogic.appcommonhandle("普通",null),
          "3": commonLogic.appcommonhandle("紧急",null),
          "2": commonLogic.appcommonhandle("特别紧急",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      VisitTaskResult: {
          "WaitingContact": commonLogic.appcommonhandle("待联系",null),
          "Connect": commonLogic.appcommonhandle("接通",null),
          "SuccessfulVisit": commonLogic.appcommonhandle("成功回访",null),
          "MakeAppointment": commonLogic.appcommonhandle("预约",null),
          "Reject": commonLogic.appcommonhandle("拒接",null),
          "Busy": commonLogic.appcommonhandle("占线",null),
          "NoAnswer": commonLogic.appcommonhandle("无人接听",null),
          "EmptyNumber": commonLogic.appcommonhandle("空号",null),
          "ShutDown": commonLogic.appcommonhandle("停机",null),
          "TurnOff": commonLogic.appcommonhandle("关机",null),
          "SelfRepair": commonLogic.appcommonhandle("用户自己维修好",null),
          "Other": commonLogic.appcommonhandle("其他",null),
          "BusyTone": commonLogic.appcommonhandle("忙音",null),
          "NotMyself": commonLogic.appcommonhandle("非本人",null),
          "NotReportedRepair": commonLogic.appcommonhandle("未报修",null),
          "Unfinished": commonLogic.appcommonhandle("未完工",null),
          "ReturnExchange": commonLogic.appcommonhandle("渠道退换货",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      KeyType: {
          "1": commonLogic.appcommonhandle("1",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      CodeList25: {
          "4": commonLogic.appcommonhandle("智能马桶",null),
          "12": commonLogic.appcommonhandle("花洒",null),
          "8": commonLogic.appcommonhandle("水龙头",null),
          "5": commonLogic.appcommonhandle("晾衣架",null),
          "9": commonLogic.appcommonhandle("浴室柜",null),
          "11": commonLogic.appcommonhandle("淋浴房",null),
          "6": commonLogic.appcommonhandle("水槽",null),
          "10": commonLogic.appcommonhandle("浴缸",null),
          "2": commonLogic.appcommonhandle("感应冲洗阀",null),
          "3": commonLogic.appcommonhandle("挂件",null),
          "7": commonLogic.appcommonhandle("水箱",null),
          "13": commonLogic.appcommonhandle("角阀",null),
          "1": commonLogic.appcommonhandle("其他",null),
          "14": commonLogic.appcommonhandle("非九牧",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      CodeList124: {
          "NotSingle": commonLogic.appcommonhandle("未派单",null),
          "WO2-Pending": commonLogic.appcommonhandle("待处理跟进",null),
          "WO3-ForServiceNetworkOrder": commonLogic.appcommonhandle("待服务网点接单",null),
          "WO4-ForServiceEngineerOrder": commonLogic.appcommonhandle("待服务工程师接单",null),
          "WO5-ForServiceEngineerAppointment": commonLogic.appcommonhandle("待服务工程师预约",null),
          "WO6-NotReachUser": commonLogic.appcommonhandle("无法联系到用户",null),
          "WO7-HasChangedAbout": commonLogic.appcommonhandle("已改约",null),
          "WO8-ToSetOut": commonLogic.appcommonhandle("待出发",null),
          "WO9-HasBeenSetOut": commonLogic.appcommonhandle("已出发",null),
          "WO10-InService": commonLogic.appcommonhandle("服务中",null),
          "WO11-ServiceAfter": commonLogic.appcommonhandle("服务完",null),
          "WO12-HaveReceipt": commonLogic.appcommonhandle("已回执",null),
          "WO13-UseuHaveEvaluation": commonLogic.appcommonhandle("用户已评价",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      PraiseType: {
          "PraiseShare": commonLogic.appcommonhandle("物业业主群好评分享",null),
          "PyqShare": commonLogic.appcommonhandle("项目管理方转发朋友圈推广",null),
          "ThanksLetter": commonLogic.appcommonhandle("项目方签章感谢信",null),
          "FlagPhoto": commonLogic.appcommonhandle("项目方赠送锦旗合照",null),
          "AppPraise": commonLogic.appcommonhandle("项目物业方APP发文好评",null),
          "MediaPraise": commonLogic.appcommonhandle("自媒体或项目内刊传播好评",null),
          "ProjectCap": commonLogic.appcommonhandle("项目优秀供应商或服务商奖杯/牌",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      VisitRuleType: {
          "ArtificialVisit": commonLogic.appcommonhandle("人工回访",null),
          "AutomaticVisit": commonLogic.appcommonhandle("自动回访",null),
          "NoVisit": commonLogic.appcommonhandle("不回访",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      VisitState: {
          "VisitEnable": commonLogic.appcommonhandle("启用",null),
          "VisitDeactivate": commonLogic.appcommonhandle("停用",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      UserLevel: {
          "3": commonLogic.appcommonhandle("普通客户",null),
          "5": commonLogic.appcommonhandle("重要客户",null),
          "4": commonLogic.appcommonhandle("特殊客户",null),
          "1": commonLogic.appcommonhandle("内部客户",null),
          "2": commonLogic.appcommonhandle("商用VIP",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      ApplyTypeKind: {
          "TrafficCompensation": commonLogic.appcommonhandle("交通费补助",null),
          "GoodCompensation": commonLogic.appcommonhandle("商誉补偿",null),
          "RebateCompensation": commonLogic.appcommonhandle("折让补偿",null),
          "Logistics": commonLogic.appcommonhandle("物流费用",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      CodeList120: {
          "WO1-Paone": commonLogic.appcommonhandle("保内",null),
          "WO2-SuchRelease": commonLogic.appcommonhandle("保外",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      CodeList128: {
          "3": commonLogic.appcommonhandle("家人",null),
          "4": commonLogic.appcommonhandle("家政",null),
          "6": commonLogic.appcommonhandle("父母",null),
          "2": commonLogic.appcommonhandle("子女",null),
          "1": commonLogic.appcommonhandle("商家",null),
          "7": commonLogic.appcommonhandle("物业",null),
          "5": commonLogic.appcommonhandle("朋友",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      ServiceTypeThird: {
          "1": commonLogic.appcommonhandle("1",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      ProductCategorySecond: {
          "empty": commonLogic.appcommonhandle("",null),
      },
      CodeList73: {
          "1": commonLogic.appcommonhandle("先生",null),
          "2": commonLogic.appcommonhandle("女士",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      VisitClassification: {
          "OrderVisit": commonLogic.appcommonhandle("工单回访任务",null),
          "ClientReview": commonLogic.appcommonhandle("客户回访",null),
          "OtherVisit": commonLogic.appcommonhandle("其他回访任务",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      WoWrongSign: {
          "1": commonLogic.appcommonhandle("堵塞",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      StimulateTypeKind: {
          "PerformanceStimulate": commonLogic.appcommonhandle("业绩激励",null),
          "TrafficDistansFalse": commonLogic.appcommonhandle("交通距离不正确",null),
          "ServeAward": commonLogic.appcommonhandle("服务规范奖",null),
          "FakeClering": commonLogic.appcommonhandle("虚假结算",null),
          "IllegalClearing": commonLogic.appcommonhandle("违规结算",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      DistributeMethod: {
          "DirectStatement": commonLogic.appcommonhandle("直接结单",null),
          "InternalAcceptance": commonLogic.appcommonhandle("内部受理",null),
          "Service": commonLogic.appcommonhandle("服务网点",null),
          "Ecommerce": commonLogic.appcommonhandle("电商",null),
          "Cabinet": commonLogic.appcommonhandle("橱柜",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      CodeList: {
          "1": commonLogic.appcommonhandle("普通",null),
          "2": commonLogic.appcommonhandle("白金",null),
          "5": commonLogic.appcommonhandle("黄金",null),
          "4": commonLogic.appcommonhandle("铂金",null),
          "3": commonLogic.appcommonhandle("至尊",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      ProductCategoryFirst: {
          "empty": commonLogic.appcommonhandle("",null),
      },
      YesNo: {
          "1": commonLogic.appcommonhandle("是",null),
          "0": commonLogic.appcommonhandle("否",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      CodeList126: {
          "Consult": commonLogic.appcommonhandle("咨询",null),
          "Complaint": commonLogic.appcommonhandle("投诉",null),
          "Suggest": commonLogic.appcommonhandle("建议",null),
          "Praise": commonLogic.appcommonhandle("表扬",null),
          "Install": commonLogic.appcommonhandle("安装",null),
          "Service": commonLogic.appcommonhandle("维修",null),
          "DismantlingOld": commonLogic.appcommonhandle("拆旧",null),
          "AboveDesign": commonLogic.appcommonhandle("上面设计",null),
          "StoreInspection": commonLogic.appcommonhandle("门店巡检",null),
          "Maintain": commonLogic.appcommonhandle("保养",null),
          "Authenticate": commonLogic.appcommonhandle("鉴定",null),
          "EngineeringInspection": commonLogic.appcommonhandle("工程巡检",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      DistirbuteSenario: {
          "ActivitySign": commonLogic.appcommonhandle("活动标识",null),
          "Normal": commonLogic.appcommonhandle("常规",null),
          "NoProductType": commonLogic.appcommonhandle("无产品类型",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      CodeList125: {
          "WO1-HasChangedAbout": commonLogic.appcommonhandle("已改约",null),
          "WO2-UserChangedAbout": commonLogic.appcommonhandle("用户改约",null),
          "WO3-ServiceChangedAbout": commonLogic.appcommonhandle("服务网点改约",null),
          "WO4-NotReachedUser": commonLogic.appcommonhandle("无法联系到用户",null),
          "WO5-CollectionNumberEmpty": commonLogic.appcommonhandle("收集号码空号",null),
          "WO6-CannotReached": commonLogic.appcommonhandle("多次联系无法接通",null),
          "WO7-Canceled": commonLogic.appcommonhandle("已取消",null),
          "WO8-UserCancel": commonLogic.appcommonhandle("客户取消",null),
          "WO9-NotDoor": commonLogic.appcommonhandle("无法上门",null),
          "WO10-HaveToHangUp": commonLogic.appcommonhandle("已挂起",null),
          "WO11-ServiceTimesGreaterTwoWeeks": commonLogic.appcommonhandle("要求服务时间跨度大于2周",null),
          "WO12-InService": commonLogic.appcommonhandle("服务中",null),
          "WO13-UnpackingDamage": commonLogic.appcommonhandle("拆包破损",null),
          "WO14-ApplicationSpareParts": commonLogic.appcommonhandle("备件申请中",null),
          "WO15-SparePartsArrival": commonLogic.appcommonhandle("备件到货",null),
          "WO16-ApplyingTechnicalSupport": commonLogic.appcommonhandle("申请技术支持中",null),
          "WO17-ApplicationReturnExchangeProgress": commonLogic.appcommonhandle("申请退换货中",null),
          "WO18-SpecialEventHandling": commonLogic.appcommonhandle("特殊事件处理中",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      ProcessingProcess: {
          "empty": commonLogic.appcommonhandle("",null),
      },
      ServiceMode: {
          "Besuch": commonLogic.appcommonhandle("上门",null),
          "SendToRepair": commonLogic.appcommonhandle("送修",null),
          "Phone": commonLogic.appcommonhandle("电话",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      EffectiveStatus: {
          "Valid": commonLogic.appcommonhandle("有效",null),
          "Invalid": commonLogic.appcommonhandle("无效",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      ExpenseType: {
          "PleaseSelect": commonLogic.appcommonhandle("请选择",null),
          "Install": commonLogic.appcommonhandle("安装",null),
          "NonInstallation": commonLogic.appcommonhandle("非安装",null),
          "ValueAdded": commonLogic.appcommonhandle("增值产品",null),
          "Other": commonLogic.appcommonhandle("其他",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      ServiceTypeSecond: {
          "3": commonLogic.appcommonhandle("不限品牌服务",null),
          "2": commonLogic.appcommonhandle("上门维修",null),
          "6": commonLogic.appcommonhandle("特殊事故",null),
          "1": commonLogic.appcommonhandle("上门咨询",null),
          "5": commonLogic.appcommonhandle("客户送修",null),
          "4": commonLogic.appcommonhandle("在线解决",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      CodeList123: {
          "400": commonLogic.appcommonhandle("400",null),
          "WeChat": commonLogic.appcommonhandle("微信",null),
          "Ecommerce": commonLogic.appcommonhandle("电商",null),
          "OfficialWebsite": commonLogic.appcommonhandle("官网",null),
          "Agent": commonLogic.appcommonhandle("电商代理商",null),
          "Channel": commonLogic.appcommonhandle("电商渠道",null),
          "Cabinet": commonLogic.appcommonhandle("橱柜",null),
          "AutoConnection": commonLogic.appcommonhandle("服务商自接",null),
          "WarrantyCard": commonLogic.appcommonhandle("电子保修卡",null),
          "Else": commonLogic.appcommonhandle("其他",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      CalculationMethod: {
          "TargetAvg": commonLogic.appcommonhandle("目标平均",null),
          "SourceAvg": commonLogic.appcommonhandle("来源平均",null),
          "SingleQuantity": commonLogic.appcommonhandle("单一数量",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      WoFuncInfoStatus: {
          "PleaseSelect": commonLogic.appcommonhandle("请选择",null),
          "Generated": commonLogic.appcommonhandle("已生成",null),
          "Confirmed": commonLogic.appcommonhandle("网点已确认",null),
          "Invoiced": commonLogic.appcommonhandle("已开票",null),
          "Reviewed": commonLogic.appcommonhandle("发票已审核",null),
          "Settled": commonLogic.appcommonhandle("财务已结算",null),
          "NextMonth": commonLogic.appcommonhandle("转次月结算",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
      CodeList119: {
          "WO1-Domestic": commonLogic.appcommonhandle("家用",null),
          "WO2-Public": commonLogic.appcommonhandle("公用",null),
          "empty": commonLogic.appcommonhandle("",null),
      },
  };
  return data;
}
export default getLocaleResourceBase;